export enum ApproveChangeRequestStatusEnum {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
}
